export default __webpack_public_path__ + "static/media/previously-assigned-marker.b2e56c75.svg";